import api from "../index"
import { apiTags } from "../tags"

const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUserProfile: build.query({
      query: (params) => ({
        url: `/profile`,
        method: "GET",
        params,
      }),
    }),
    changePassword: build.query({
      query: (changePasswordCredentials) => ({
        url: `/users/profile/password`,
        method: "POST",
        body: changePasswordCredentials,
      }),
    }),
    updatePassword: build.mutation({
      query: (body) => {
        return {
          url: `/update/password`,
          method: "POST",
          body,
        }
      },
    }),
    getUsers: build.query({
      query: (params) => ({
        url: `/users`,
        method: "GET",
        params,
      }),
    }),
    getUser: build.query({
      query: ({ id }) => ({
        url: `/users/${id}`,
        method: "GET",
      }),
    }),
    createUser: build.mutation({
      query: (params) => ({
        url: `/users`,
        method: "POST",
        body: params,
      }),
    }),
    updateUser: build.mutation({
      query: ({ id, ...params }) => ({
        url: `/users/${id}`,
        method: "POST",
        body: params,
      }),
    }),
    deleteUser: build.mutation({
      query: ({ id }) => ({
        url: `/users/${id}`,
        method: "DELETE",
      }),
    }),
    blockUser: build.mutation({
      query: ({ id }) => ({
        url: `/users/${id}/block`,
        method: "GET",
      }),
    }),
    unblockUser: build.mutation({
      query: ({ id }) => ({
        url: `/users/${id}/unblock`,
        method: "GET",
      }),
    }),
    logout: build.mutation({
      query: () => ({
        url: `/logout`,
        method: "GET",
      }),
    }),
    getAdminByToken: build.query({
      query: ({ token }) => ({
        url: `/public/admin/bytoken/${token}`,
        method: "GET",
      }),
    }),
    verifyAdminOTP: build.mutation({
      query: (body) => ({
        url: `/public/admin/verifyOTP`,
        method: "POST",
        body,
      }),
    }),
    sendAdminOTP: build.mutation({
      query: (body) => ({
        url: `/public/admin/sendOTP`,
        method: "POST",
        body,
      }),
    }),

    readNotification: build.mutation({
      query: (id) => ({
        url: `/notification/read/${id}`,
        method: "put",
      }),
    }),
  }),
})

export const {
  useLazyGetUserProfileQuery,
  useGetUserProfileQuery,
  useLazyChangePasswordQuery,
  useUpdatePasswordMutation,
  useLazyGetUsersQuery,
  useLazyGetUserQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useBlockUserMutation,
  useUnblockUserMutation,
  useLogoutMutation,
  useLazyGetAdminByTokenQuery,
  useVerifyAdminOTPMutation,
  useSendAdminOTPMutation,
  useReadNotificationMutation,
} = userApi
